import { FormattedMessage } from 'react-intl';

import { AtlassianIntelligenceIcon } from '@trello/nachos/icons/atlassian-intelligence';
import { ActionTestIds } from '@trello/test-ids';

import styles from './ActionAppCreator.less';

export interface ActionAppCreatorProps {
  appCreator: {
    name: string;
    idPlugin?: string;
    iconClass?: string;
  };
  canLinkAppCreator: boolean;
}

export const ActionAppCreator = ({
  appCreator,
  canLinkAppCreator,
}: ActionAppCreatorProps) => {
  const appCreatorName =
    appCreator.idPlugin && canLinkAppCreator ? (
      <a className="quiet js-app-creator-link" href="#">
        {appCreator.name}
      </a>
    ) : (
      appCreator.name
    );

  let appCreatorIcon: JSX.Element | null;
  if (appCreator?.iconClass) {
    appCreatorIcon = (
      <span
        className={`app-creator-icon icon-sm ${appCreator.iconClass}`}
        data-testid={ActionTestIds.AppCreatorIcon}
      ></span>
    );
  } else if (appCreator.name === 'Atlassian Intelligence') {
    appCreatorIcon = (
      <AtlassianIntelligenceIcon
        dangerous_className={styles.aiIcon}
        testId={ActionTestIds.AppCreatorIcon}
      />
    );
  } else {
    appCreatorIcon = null;
  }

  return (
    <span>
      {' '}
      <FormattedMessage
        id="templates.action.via"
        defaultMessage="via {integrationName}"
        description="Message showing which app created the action, with link when available"
        values={{
          integrationName: (
            <>
              {appCreatorIcon}
              {appCreatorName}
            </>
          ),
        }}
      />
    </span>
  );
};
